import store from '@/store.js'
import AsyncUtils from '@/scripts/utils/async'
import RandomUtils from '@/scripts/utils/random'

// how long we will wait between glitches (milliseconds)
const MinWait = 20000
const MaxWait = 40000

// how long we will glitch for (milliseconds)
const MinGlitchTime = 100
const MaxGlitchTime = 300
let status = false
export default {

  // Starts the glitch controller
  async Start() {
    status = true
    // eslint-disable-next-line
    while (status) {

      store.commit('setGlitch', false)
      // wait for next glitch
      let wait = RandomUtils.RandomNumber(MinWait, MaxWait)
      await AsyncUtils.Sleep(wait)

      //unglitch
      store.commit('setGlitch', true)
      await AsyncUtils.Sleep(RandomUtils.RandomNumber(MinGlitchTime, MaxGlitchTime))
    }
  },
  Stop() {
    status = false
  }

}